import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const GUEST_KEY = "medtravel_guest_id";

export function getOrCreateGuestId() {
  let id = localStorage.getItem(GUEST_KEY);
  if (!id) {
    id = "g_" + Math.random().toString(36).slice(2, 12) + Date.now().toString(36);
    localStorage.setItem(GUEST_KEY, id);
  }
  return id;
}

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  config.headers["X-Guest-Id"] = getOrCreateGuestId();
  return config;
});

/**
 * Start the direct Stripe Checkout flow used by every landing-page CTA.
 * Creates a public checkout session and full-page redirects to Stripe.
 * After payment, Stripe routes the user to /onboard?session_id=… where
 * they finish creating their account.
 *
 * @param {"monthly"|"yearly"|"yearly_b"} plan — defaults to yearly ($49.50/yr)
 */
export async function startDirectCheckout(plan = "yearly") {
  const { data } = await api.post("/checkout-session", {
    origin_url: window.location.origin,
    plan,
  });
  if (!data?.url) throw new Error("Stripe returned no checkout URL");
  window.location.href = data.url;
}
